import { PermissionContextDto } from "@Front/Api/LeCoffreApi/SuperAdmin/RolePermissions/RolePermissions";
import { resolveUserContext } from "@Front/Utils/userContextResolver";
import { isAdminRole, isOfficeAdminRole, isSuperAdminRole } from "@Front/Utils/officeRoleStatusHelpers";

export function checkIsSuperAdmin(permissionContext: PermissionContextDto | null | undefined): boolean {
	return permissionContext?.isSuperAdmin === true || isSuperAdminRole(permissionContext?.globalRole);
}

function isGuestInOffice(
	resolvedContext: ReturnType<typeof resolveUserContext>,
	officeUid: string | null | undefined,
	roleInOffice: string | null | undefined,
): boolean {
	if (officeUid === "GUEST_FOLDERS") return true;
	if (officeUid && roleInOffice) return false;
	if (resolvedContext.isInvitedNotary && !roleInOffice) return true;
	if (!roleInOffice && officeUid) return true;
	return false;
}

/**
 * Returns true if the user is admin of their office (e.g. Notaire associé).
 * When globalRole is "admin", returns true even when currently viewing as guest (GUEST_FOLDERS),
 * so that an admin who became notaire invité still sees their admin status and Espace office.
 */
export function checkIsOfficeAdmin(
	permissionContext: PermissionContextDto | null | undefined,
	roleInOffice: string | null | undefined,
	officeUid: string | null | undefined,
): boolean {
	const globalRole = permissionContext?.globalRole ?? null;
	if (isAdminRole(globalRole)) return true;
	const resolvedContext = resolveUserContext(permissionContext);
	if (isGuestInOffice(resolvedContext, officeUid, roleInOffice)) return false;
	const officeRoleFromContext = typeof permissionContext?.officeRole === "string" ? permissionContext.officeRole : "";
	const officeRoleName = roleInOffice || officeRoleFromContext;
	return isOfficeAdminRole(globalRole, officeRoleName);
}
